<lib-auth-reset-password
  (usernameSubmitted)="reset($event)"
></lib-auth-reset-password>
